module.exports = __webpack_public_path__ + "static/media/slide2.4976c8ae.png";